import { XStack } from "@/components";
import { Link, Text } from "@/components/Typography";

type AnnouncementBannerProps = {
  message: string;
  linkHref?: string;
  externalLinkHref?: string;
};

export default function AnnouncementBanner({
  message,
  linkHref,
  externalLinkHref,
}: AnnouncementBannerProps) {
  const href = externalLinkHref ?? linkHref;

  return (
    <XStack
      backgroundColor="$fillBadgeTertiary"
      paddingHorizontal="$400"
      paddingVertical="$200"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      {href ? (
        <Link href={href as any} external={!!externalLinkHref}>
          <Text size="$sm" textAlign="center">
            {message}
          </Text>
        </Link>
      ) : (
        <Text size="$sm" textAlign="center">
          {message}
        </Text>
      )}
    </XStack>
  );
}
